import type { FieldDailyReport, FieldSiteMember, FieldTitul } from './types';

/** Не пытаемся угадать титул по шифру файла или названию площадки. */
export function titulLabel(
  tituls: readonly FieldTitul[],
  titulId: string | null | undefined,
): string {
  const titul = tituls.find((t) => t.id === titulId);
  return titul ? `${titul.code} — ${titul.name}` : 'Не распределено по титулам';
}

export function reportAuthorLabel(
  report: Pick<FieldDailyReport, 'author_id' | 'author_name'>,
  members: readonly FieldSiteMember[],
  currentUserId?: string,
): string {
  const serverName = report.author_name?.trim();
  if (serverName) return serverName;
  if (!report.author_id) return 'Автор прежнего рапорта не указан';
  const name = members.find((m) => m.user_id === report.author_id)?.full_name?.trim();
  return (
    name || (report.author_id === currentUserId ? 'Вы' : `Сотрудник ${report.author_id.slice(-8)}`)
  );
}

export function canWritePersonalReport(input: {
  authorId: string | null | undefined;
  userId: string | undefined;
  status: string;
  siteWriter: boolean;
}): boolean {
  return (
    !!input.userId &&
    input.authorId === input.userId &&
    input.siteWriter &&
    ['draft', 'returned'].includes(input.status)
  );
}

/** Только явный член текущего проекта; смена проекта не сохраняет старые документы. */
export function projectDocumentSelection(
  documents: readonly { id: string; project_id: string }[],
  selectedIds: readonly string[],
  projectId: string,
): string[] {
  const allowed = new Set(documents.filter((d) => d.project_id === projectId).map((d) => d.id));
  return [...new Set(selectedIds)].filter((id) => allowed.has(id));
}

/** Дата смены определяется часовым поясом площадки, а не офисного браузера. */
export function siteShiftDate(timezone: string, date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}
